/**
 * Created by Greg on 4/8/2016.
 * Based on code from https://gist.github.com/burgalon/870a68de68c5ed15c416fab63589d503
 * 
 */
import React from 'react';
import {Modal} from 'react-bootstrap'
import ModalDialog from 'react-bootstrap/lib/ModalDialog'
import Draggable from 'react-draggable';

export default class DraggableModalDialog extends React.Component {
    render() {
        return <Draggable handle=".modal-header"><ModalDialog {...this.props} /></Draggable>
    }
}

/* Example usage: (note that the enforceFocus={false} is important here).

            <Modal dialogComponent={DraggableModalDialog}
           enforceFocus={false} backdrop="static" show={this.props.open} onHide={this.props.close}
                   dialogClassName="add-node-net-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add a Network Node</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                ... Just the usual stuff here.
  */


// WEBPACK FOOTER //
// ./src/DraggableModal.js